


































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { firmRecommend } from "@/req/homes";
import qs from "@/components/queSheng.vue";

@Component({
  components: { qs },
})
export default class Home extends Vue {
  @Prop({ type: Number, default: null }) public factoryId;
  public list: any = [];
  public gameId: any = "";
  public mounted() {
    this.gameId = this.$route.query.id;
    setTimeout(() => {
      this.getList();
    }, 500);
  }
  @Watch("$route.query.id")
  public change() {
    this.gameId = this.$route.query.id;
    this.getList();
  }
  public async getList() {
    this.list = [];
    const obj = {
      token: this.$fn.cookies.getToken(),
      factory_id: this.factoryId,
      box_game_id: this.gameId,
    };
    const res = await firmRecommend(obj);
    if (res.code == 200) {
      this.list = res.data.game_list.data;
    }
  }
  public toTags(list) {
    if (!list) {
      return [];
    }
    if (!this.factoryId) {
      return [];
    }
    const arr = list.split("|");
    return arr;
  }
  public toGame(items) {
    this.$router.push({
      path: "/gameDetail",
      query: { id: items.box_game_id },
    });
  }
}
